import React from 'react'
import styled from 'styled-components'

import { colors } from '../../../constants'

const Wrapper = styled.div`
  align-items: center;
  color: ${colors.grey};
  display: flex;
  height: 100%;
  justify-content: center;
  width 100%;
`

const NoResults = () => <Wrapper />

export default NoResults
